export const dateInPast = (date) => {
  if (typeof date === "number") {
    return date < Date.now()
  }
  return new Date(date).getTime() < Date.now()
}


// WEBPACK FOOTER //
// src/utils/date_utils.js